module.exports = vendors_tr_dd0b387d7fcd7dfdbc1c;